import { saveContent } from '@paragon/client-tools';
import { UploadedFile } from '@paragon/component-processor';
import { addSpinnerMessage, removeSpinnerMessage } from '@paragon/task-spinner';

import { convert } from '../data/convertCompareCount';
import { addConversionResult } from '../store/conversionResultsSlice';
import { prepareFileDataForUpload } from './files';
import { AsyncThunkActionVoid } from './thunkActions';

export const convertFiles =
  (
    convertToFileType: string,
    fileData: readonly UploadedFile[],
    numberOfFilesBeingConverted: number,
  ): AsyncThunkActionVoid =>
  async (dispatch) => {
    const spinnerId = dispatch(addSpinnerMessage('Converting files...'));

    const transformedFileData = await prepareFileDataForUpload(fileData);
    const conversionResults = await convert(convertToFileType, transformedFileData).catch(() => {
      alert('Error converting.');
      dispatch(removeSpinnerMessage(spinnerId));
    });

    if (conversionResults != null) {
      if (conversionResults.convertedFilesZipUrl) {
        saveContent('ConvertedFiles.zip', conversionResults.convertedFilesZipUrl);
      }
      const payload = {
        numberOfFilesSubmitted: numberOfFilesBeingConverted,
        failedConversions: conversionResults.failedConversions,
        guid: conversionResults.guid,
      };
      dispatch(addConversionResult(payload));
    }

    dispatch(removeSpinnerMessage(spinnerId));
  };
